var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainuserworkspace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2696 721)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2696 -721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2732.75-721v18.751l-6.622-3.892v7.531l-15.045-7.311v7.295c-.268-.117-.461-.195-.648-.285l-14.009-6.813c-.139-.068-.285-.122-.428-.183V-673h48v-48Zm-33.906,45.164v-25.586l15.037,7.309v-7.321l15.058,7.317v-7.093c.216.12.362.2.5.282q5.668,3.34,11.341,6.672a.729.729,0,0,1,.411.737q-.017,8.578-.008,17.156v.526Zm42.332-21.464c-.193-.106-.329-.175-.46-.252-1.586-.933-3.167-1.876-4.762-2.794a.686.686,0,0,1-.4-.689q.018-8.337.01-16.674c0-.15.014-.3.021-.444h5.594Z",
    transform: "translate(-2696 721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2967.354-380.354h14.067v-8.4h-14.067Zm2.813-2.813v-2.772h8.441v2.772Z",
    transform: "translate(-2941.914 419.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2786.6-380.363h14.067v-8.4H2786.6Zm2.806-5.59h8.453v2.77H2789.4Z",
    transform: "translate(-2778.104 419.908)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainuserworkspace);
export default __webpack_public_path__ + "static/media/mainـuserworkspace.f0f8883ec0b45643df99146e4b81aa1b.svg";
export { ForwardRef as ReactComponent };